import {
  Box,
  Center,
  Flex,
  Text,
  Spinner,
  Button,
  Icon,
} from "@chakra-ui/react";
import { useRecoilValue } from "recoil";
import * as state from "../state";
import { CorrectIcon, PassIcon } from "./icons";
const Content = () => {
  const data = useRecoilValue(state.data);
  return (
    <>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="100%"
        height="85vh"
      >
        {data.word ? (
          <Flex
            width={["50vw", "50vw"]}
            paddingX="2"
            flexDirection="column"
            alignItems={["baseline", "center"]}
          >
            <Flex
              width="100%"
              gap="2"
              alignItems="center"
              paddingX="5"
              justifyContent="space-evenly"
            >
              <Button size="lg" _hover={{ bg: "green.500", color: "white" }}>
                <Icon as={CorrectIcon} />
              </Button>
              <Text fontSize={["5xl", "7xl"]} fontWeight="bold">
                {data.word}
              </Text>
              <Button size="lg" _hover={{ bg: "red.500", color: "white" }}>
                <Icon as={PassIcon} />
              </Button>
            </Flex>
            <Text fontSize={["md", "xl"]}>{data.definition}</Text>
          </Flex>
        ) : (
          <Spinner />
        )}
      </Box>
      <Box position="absolute" width="100vw" bottom="0" left="0" padding="3">
        <Flex paddingX="3" justifyContent="space-between" alignItems="center">
          <Text fontSize={["3xl", "5xl"]}>
            {data ? data.partOfSpeech : <Spinner />}
          </Text>
          <Text fontSize={["3xl", "5xl"]}></Text>
        </Flex>
      </Box>
    </>
  );
};

export default Content;
